import { createReducer } from '@reduxjs/toolkit';
import {
  clearAgencyMfaAction,
  discardAgencyMfaDraftAction,
  setAgencyMfaDraftAction,
  setAgencyMfaErrorAction,
  setAgencyMfaLoadingAction,
  setAgencyMfaPolicyAction,
  setAgencyMfaSavedAction,
  setAgencyMfaSavingAction,
} from 'store/actions/agency-mfa-actions';
import { IAgencyMfaState } from 'types/mfa/IAgencyMfaPolicy';

const initialState: IAgencyMfaState = {
  saved: null,
  draft: null,
  loading: false,
  saving: false,
  errorKey: null,
};

const agencyMfaReducer = createReducer(initialState, builder =>
  builder
    // A fresh server read resets the draft too: the form is clean immediately after a load.
    .addCase(setAgencyMfaPolicyAction, (state, action) => ({
      ...state,
      saved: action.payload,
      draft: action.payload,
    }))
    .addCase(setAgencyMfaSavedAction, (state, action) => ({ ...state, saved: action.payload }))
    .addCase(setAgencyMfaDraftAction, (state, action) => ({ ...state, draft: action.payload }))
    .addCase(discardAgencyMfaDraftAction, state => ({ ...state, draft: state.saved }))
    .addCase(setAgencyMfaLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setAgencyMfaSavingAction, (state, action) => ({ ...state, saving: action.payload }))
    .addCase(setAgencyMfaErrorAction, (state, action) => ({ ...state, errorKey: action.payload }))
    .addCase(clearAgencyMfaAction, () => ({ ...initialState })),
);

export default agencyMfaReducer;
